import { useBoardProvider } from "../../contexts/board/boardContext";
import { useUpdateView } from "../../data/mutations/viewMutations";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useDueDatesAuth } from "../../hooks/useDueDatesAuth";

export const FavoritesNavItem = ({ view }) => {
  const navigate = useNavigate();
  const { mutate: updateView } = useUpdateView();
  const { currentBoardId } = useBoardProvider();
  const queryClient = useQueryClient();
  const { UserId } = useDueDatesAuth();

  const handleFavoriteChange = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const updatedView = {
      Id: view?.Id,
      Name: view?.Name,
      IsFavorite: !view?.IsFavorite,
      Order: view?.Order,
      UserId: UserId,
      BoardId: currentBoardId,
    };

    updateView(
      { view: updatedView },
      {
        onSuccess: (res) => {
          const { UpdatedEntity } = res;

          queryClient.setQueryData(
            ["get-views", UpdatedEntity.BoardId],
            (old) => {
              const updatedViews = old?.map((v) => {
                if (v.Id === UpdatedEntity.Id) {
                  return {
                    ...v,
                    IsFavorite: updatedView?.IsFavorite,
                  };
                }

                return v;
              });

              return updatedViews;
            }
          );

          if (location.pathname.includes("views/favorites"))
            navigate("/duedates/views/assignedtome");
        },
      }
    );
  };

  return (
    <div className="d-flex justify-content-start align-items-center gap-2">
      <i
        className="fa-solid fa-star et-orange-light-2 fs-12 ps-2"
        onClick={handleFavoriteChange}
      />
      {view?.Name}
    </div>
  );
};
